<template>
  <div id="create-live-stream-dialog" class="custom-modal">
    <div class="modal-body">
      <transition name="el-fade-in" mode="out-in">
        <HolaconLottie v-if="loading == 'updateScreenLoading'" key="create-loading" />
        <el-row v-else key="content-loading">
          <el-row :gutter="10">
            <el-col :span="24">
              <div class="live-type-container">
                <!-- <div class="item" :class="{ active: form.sessionType == 0 }" @click="form.sessionType = 0">
                  <div class="logo-side">
                    <img src="../../../static/images/stream/holacon.svg" alt="" />
                  </div>
                  <div class="text-side">
                    {{ $t("liveSessions.createLiveStream.holaconMsg") }}
                  </div>
                </div> -->
                <div class="item" :class="{ active: form.sessionType == 1 }" @click="true ? form.sessionType = 1 : from.sessionType = 0">
                  <upgrade-overlay position="absolute" :onlyButton="true" v-if="false"></upgrade-overlay>
                  <div class="logo-side">
                    <img src="../../../static/images/stream/rtmp.svg" width="100%" alt="" />
                  </div>
                  <div class="text-side">
                    {{ $t("liveSessions.createLiveStream.rtmpMsg") }}
                  </div>
                </div>
                <div class="item" :class="{ active: form.sessionType == 2 }" @click="form.sessionType = 2">
                  <div class="logo-side">
                    <!-- <img src="../../../static/images/stream/vimeo.svg" alt="" /> -->
                    <i class="fa fa-code" style="font-size:82px; color:black"></i>
                  </div>
                  <div class="text-side">
                    {{ $t("liveSessions.createLiveStream.vimeoMsg") }}
                  </div>
                </div>
              </div>
              <span class="error">{{ $errorMessage("sessionType", validationErrors) }}</span>
            </el-col>
          </el-row>

          <el-row :gutter="20" class="mt-3">
            <el-col :span="16">
              <el-row :gutter="10">
                <el-col :span="24">
                  <div class="registerform-input-container">
                    <div class="title">
                      <div>
                        <label>{{ $t("liveSessions.createLiveStream.title") }}</label>
                        <el-tooltip placement="top">
                          <div slot="content" class="custom-tooltip-content">
                            <span>{{ $t("liveSessions.createLiveStream.titleMsg") }}</span>
                          </div>
                          <i class="el-icon-info"></i>
                        </el-tooltip>
                      </div>
                    </div>
                    <el-input v-model="form.title"></el-input>
                    <span class="error">{{ $errorMessage("title", validationErrors) }}</span>
                  </div>
                </el-col>

                <el-col :span="14" class="mt-3">
                  <div class="registerform-input-container">
                    <div class="title">
                      <div>
                        <label>{{ $t("liveSessions.createLiveStream.startDate") }}</label>
                        <el-tooltip placement="top">
                          <div slot="content" class="custom-tooltip-content">
                            <span>{{ $t("liveSessions.createLiveStream.startDateMsg") }}</span>
                          </div>
                          <i class="el-icon-info"></i>
                        </el-tooltip>
                      </div>
                    </div>
                    <el-date-picker :format="datePickerDisplayFormat()" v-model="form.startDate" class="w-100" type="date" :placeholder="$t('liveSessions.createLiveStream.placeholderChooseDate')"></el-date-picker>
                    <span class="error">{{ $errorMessage("startDate", validationErrors) }}</span>
                  </div>
                </el-col>

                <el-col :span="10" class="mt-3">
                  <div class="registerform-input-container">
                    <div class="title">
                      <div>
                        <label>{{ $t("liveSessions.createLiveStream.startTime") }}</label>
                        <el-tooltip placement="top">
                          <div slot="content" class="custom-tooltip-content">
                            <span>{{ $t("liveSessions.createLiveStream.startTimeMsg") }}</span>
                          </div>
                          <i class="el-icon-info"></i>
                        </el-tooltip>
                      </div>
                    </div>
                    <el-time-select style="width:100%;" v-model="form.startTime" :placeholder="$t('liveSessions.createLiveStream.placeholderChooseHour')" :picker-options="{ start: '00:00', step: '00:05', end: '23:59' }"></el-time-select>
                    <span class="error">{{ $errorMessage("startTime", validationErrors) }}</span>
                  </div>
                </el-col>

                <el-col :span="14" class="mt-3">
                  <div class="registerform-input-container">
                    <div class="title">
                      <div>
                        <label>{{ $t("liveSessions.createLiveStream.endDate") }}</label>
                        <el-tooltip placement="top">
                          <div slot="content" class="custom-tooltip-content">
                            <span>{{ $t("liveSessions.createLiveStream.endDateMsg") }}</span>
                          </div>
                          <i class="el-icon-info"></i>
                        </el-tooltip>
                      </div>
                    </div>
                    <el-date-picker :format="datePickerDisplayFormat()" v-model="form.endDate" type="date" class="w-100" :placeholder="$t('liveSessions.createLiveStream.placeholderChooseDate')"></el-date-picker>
                    <span class="error">{{ $errorMessage("endDate", validationErrors) }}</span>
                  </div>
                </el-col>

                <el-col :span="10" class="mt-3">
                  <div class="registerform-input-container">
                    <div class="title">
                      <div>
                        <label>{{ $t("liveSessions.createLiveStream.endTime") }}</label>
                        <el-tooltip placement="top">
                          <div slot="content" class="custom-tooltip-content">
                            <span>{{ $t("liveSessions.createLiveStream.endTimeMsg") }}</span>
                          </div>
                          <i class="el-icon-info"></i>
                        </el-tooltip>
                      </div>
                    </div>
                    <el-time-select style="width:100%;" v-model="form.endTime" :placeholder="$t('liveSessions.createLiveStream.placeholderChooseHour')" :picker-options="{ start: '00:00', step: '00:05', end: '23:59' }"></el-time-select>
                    <span class="error">{{ $errorMessage("endTime", validationErrors) }}</span>
                  </div>
                </el-col>
              </el-row>
            </el-col>

            <el-col :span="8">
              <div class="registerform-input-container">
                <div class="title">
                  <div>
                    <label>{{ $t("liveSessions.createLiveStream.coverImg") }}</label>
                    <el-tooltip placement="top">
                      <div slot="content" class="custom-tooltip-content">
                        <span>{{ $t("liveSessions.createLiveStream.coverImgMsg") }}</span>
                      </div>
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                </div>
                <div class="mage-maker drag" :style="{ background: form.image ? `url(${$imageus + form.image + '?width=1120&height=500&mode=cover'})` : 'none', 'border-radius': '5px' }">
                  <el-upload :onProgress="liveProgress" :style="{ opacity: !!form.image ? '0' : '1' }" class="avatar-uploader cover-uploader" :action="axios.defaults.baseURL + 'event/uploadImage?uploadType=liveEvent&language=' + $i18n.locale" :headers="{ Authorization: axios.defaults.headers['Authorization'] }" drag :show-file-list="false" :on-success="liveSuccess">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text" v-html="$t('generic.uploadText')"></div>
                  </el-upload>
                </div>
                <!-- <el-upload
                  :onProgress="liveProgress"
                  class="avatar-uploader cover-uploader"
                  :action="axios.defaults.baseURL + 'event/uploadImage?uploadType=liveEvent&language='+$i18n.locale"
                  :headers="{ Authorization: axios.defaults.headers['Authorization'], }" :show-file-list="false" :on-success="liveSuccess">
                  <img v-if="form.image" :src="$imageus + form.image + '?width=1120&height=500&mode=cover'" class="avatar" />
                  <i v-else class="fas fa-plus avatar-uploader-icon"></i>
                </el-upload> -->
                <span class="error">{{ $errorMessage("image", validationErrors) }}</span>
              </div>
            </el-col>
          </el-row>
        </el-row>
      </transition>
    </div>
    <div class="modal-footer" slot="footer" v-if="loading != 'updateScreenLoading'">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("liveSessions.createLiveStream.close") }}</el-button>
        <!-- <el-popconfirm @confirm="deleteItem" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
          <el-button slot="reference" type="danger" icon="fas fa-trash"> Sil</el-button>
        </el-popconfirm> -->
      </div>
      <div class="right-buttons">
        <el-button type="primary" @click="save">{{ $t("liveSessions.createLiveStream.save") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      axios,
      loading: false,
      timeout: null,
      validationErrors: [],
      form: {
        sessionType: 1,
        title: null,
        startDate: null,
        endDate: null,
        startTime: null,
        endTime: null,
        image: null,
        livePercent: 0
      }
    };
  },
  created() {
    this.loading = "updateScreenLoading";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.loading = false;
    }, 500);
  },
  methods: {
    async save() {
      this.validationErrors = [];
      var res = await this.$store.dispatch("createLiveStream", this.form);
      this.validationErrors = res.data.validationErrors;
      if (!res.data.alert.hasError) {
        this.$emit("closeDialog");
      }
    },
    liveProgress(event) {
      this.livePercent = event.percent;
    },
    liveSuccess(response) {
      this.livePercent = 0;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.form.image = response.data.item.url;
      }
    }
  },
  computed: {
    eventPermissions() {
      return this.$store.getters.getEventPermission;
    }
  }
};
</script>

<style lang="less" scoped>
#create-live-stream-dialog {
  .create-live-head {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
    font-weight: bold;
    color: black;
    span {
      font-weight: 400;
    }
  }
  .live-type-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;

    .item {
      justify-content: center;
      padding: 1rem;
      border: 4px solid #f1f1f1;
      height: 200px;
      display: flex;
      flex-direction: column;
      border-radius: 8px;
      cursor: pointer;
      gap: 1rem;
      position: relative;
      background-color: #f1f1f1;
      transition: all 0.3s ease-in-out;

      .coming-soon {
        position: absolute;
        background-color: #6457f9;
        border-radius: 14px;
        padding: 10px 16px;
        top: -12px;

        span {
          color: white;
          font-weight: 500;
          font-size: 14px;
        }

        &:before {
          content: "";
          position: absolute;
          top: 100%;
          left: 60px;
          width: 0;
          border-top: 12px solid #6457f9;
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
        }
      }

      &:nth-child(1) {
        .logo-side {
          img {
            width: 42%;
            height: auto;
            margin-bottom: 6px;
          }
        }
      }

      &:nth-child(2) {
        .logo-side {
          img {
            width: 55%;
            height: auto;
            margin-top: 13px;
          }
        }
      }

      &:nth-child(3) {
        .logo-side {
          img {
            width: 60%;
            height: auto;
            margin-bottom: 9px;
          }
        }
      }

      &:nth-child(4) {
        .logo-side {
          img {
            width: 52%;
            height: auto;
          }
        }
      }

      .logo-side {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 90px;
      }

      .text-side {
        text-align: center;
        color: black;
        font-weight: 500;
      }
      &.active {
        border-color: #03658c;
        transition: all 0.3s ease-in-out;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/live-stream/createLiveStream.vue